// 文本类型

export const contentType = [
    { value: 'CHECK_IN', text: '入住须知' },
    { value: 'VISIT_LOGIN_NOTICE', text: '关于开放预约探视的通知' },
    { value: 'VISIT_INDEX_NOTICE', text: '市社会福利院关于疫情防控期间实行预约探视的告知书' },
    { value: 'SEND_A_LETTER', text: '致我市养老机构入住老年人及其家属的一封信' },
];
